import { createAction, props } from '@ngrx/store';

export const DecedentInfoUpdate = createAction('[Decedent Info] Update', props<{ payload: any }>());
export const OpenDecedentInfoReviewModal = createAction('[Decedent Info] Open Review Modal');
export const CloseDecedentInfoReviewModal = createAction('[Decedent Info] Close Review Modal');
export const DecedentIdExceededAttempts = createAction(
  '[Decedent Info] Decedent Id Exceeded Attempts',
);

export const IsDeathVerifiedUpdate = createAction(
  '[Decedent Info] Update isDeathVerified',
  props<{
    payload: {
      isDeathVerified: boolean;
    };
  }>(),
);
